import { ReactElement, useCallback } from "react";
import { localize } from "client_legacy/ndaw/culture";
import styles from "./CompleteStep.module.less";
import { WelcomeStep } from "./WelcomeStep/WelcomeStep";
import image from "Content/Images/complete-step.svg";
import { ContentLayout } from "./ContentLayout";
import { HelpfulResourceCard, HelpfulResourceCardConfiguration } from "./HelpfulResourceCard";

export type CompleteStepProps = {
	onNext: () => void;
};

export const CompleteStep = (props: CompleteStepProps): ReactElement => {
	const { onNext } = props;

	const continueHandler = useCallback(
		(): void => {
			onNext();
		},
		[onNext]
	);

	return (
		<>
			<WelcomeStep.Left trackingId="complete-step">
				<ContentLayout
					title={localize("_WeHaveSetUpYourWorkspace")}
					titleIcon={{ kind: "svg", name: "party-popper" }}
					explanation={localize("_ToGetTheMostOutOfYourWorkspaceHereAreSomeHelpfulResourcesToGetStarted")}
				>
					<ul className={styles.cards}>
						{helpfulResourceCardConfiguration.map((x, i): ReactElement => (
							<li key={i}>
								<HelpfulResourceCard
									configuration={x}
								/>
							</li>
						))}
					</ul>

					<ContentLayout.Buttons
						onContinue={continueHandler}
						primaryButtonText={localize("_GoToMyWorkspace")}
					/>
				</ContentLayout>

			</WelcomeStep.Left>

			<WelcomeStep.Right
				imageUrl={image}
				text={localize("_YouCanDownloadOurMobileAppInTheAppStore")}
			/>
		</>
	);
};

CompleteStep.displayName = "CompleteStep";

export const helpfulResourceCardConfiguration: readonly HelpfulResourceCardConfiguration[] = [
	{
		titleKey: "_ProductDemo",
		descriptionKey: "_ProductDemoDescription",
		timeInMinutes: 5,
		urls: {
			"standard": "https://newdayatworkpartner.sharepoint.com/:b:/s/SupportHub/EdAVZnRuOvZFh3qb1xe1tvkBI4jbcIZ1eXhXa60wAFRfZA?e=aJ6u2m",
			"nl": "https://newdayatworkpartner.sharepoint.com/:b:/s/SupportHub/EWkfiQYmXPFEplSWG6FBRuYBlCC8-n8HwQWGJuDjl7l7Ng?e=4x93qj"
		}
	}
];
